import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminApprovalRequestDetailView,
  AdminApprovalRequestsPage,
  AdminApprovalRequestsQuery,
} from 'shared-models/browser';

export type {
  AdminApprovalRequestDetailView,
  AdminApprovalRequestSearchField,
  AdminApprovalRequestsPage,
  AdminApprovalRequestsQuery,
  AdminApprovalRequestView,
} from 'shared-models/browser';

class AdminApprovalRequestsService {
  async list(query: AdminApprovalRequestsQuery = {}): Promise<AdminApprovalRequestsPage> {
    try {
      const response = await authenticatedInstance.get<AdminApprovalRequestsPage>('/approvals/admin/audit', {
        params: query,
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת בקשות האישור נכשלה'));
    }
  }

  async getDetail(requestId: number): Promise<AdminApprovalRequestDetailView> {
    try {
      const response = await authenticatedInstance.get<AdminApprovalRequestDetailView>(`/approvals/admin/audit/${requestId}`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת פרטי בקשת האישור נכשלה'));
    }
  }
}

export const adminApprovalRequestsService = new AdminApprovalRequestsService();
